import * as z from 'zod';

import { contactQueryLinkerSchema } from '@/_pages/contacts/shared';
import { fileQuerySchema } from '@/_schemas/file';
import { currencyInput, paginatedResponseSchema } from '@/_schemas/generic';

import { campaignTypeQuerySchema } from './campaign-type-options';
import { companyFilteredSchema } from './linked-schemas';
import { marketingCampaignQueryLinkerSchema } from './marketing-campaigns-query-linker-schema';

export const marketingCampaignQuerySchema = z.object({
  ...marketingCampaignQueryLinkerSchema.shape,

  campaign_type: campaignTypeQuerySchema,
  date: z.string().nullish(),
  notes: z.string().nullish(),
  total_cost_of_campaign: currencyInput.querySchema(),
  clients: z.array(companyFilteredSchema),
  contacts: z.array(contactQueryLinkerSchema),
  attached_files: z.array(fileQuerySchema).nullish(),
  contacts_count: z.number(),
});

export type MarketingCampaignQuerySchema = z.infer<typeof marketingCampaignQuerySchema>;

export const marketingCampaignQueryAllSchema = paginatedResponseSchema(marketingCampaignQuerySchema);

export type MarketingCampaignQueryAllSchema = z.infer<typeof marketingCampaignQueryAllSchema>;
